// Saudi phone validators
// Accepts: +9665XXXXXXXX or 05XXXXXXXX
const SAUDI_RE = /^(\+9665\d{8}|05\d{8})$/;
const SAUDI_RE_LIVE = /^(\+9665\d{0,8}|05\d{0,8}|0|\+9|\+96|\+966|\+9665|)$/; // permissive while typing

export function normalizeSaudi(p) {
  if (!p) return "";
  const s = String(p).replace(/[\s-]/g, "");
  if (/^05\d{8}$/.test(s)) return "+9665" + s.slice(2);
  return s;
}

export function isValidSaudi(p) {
  if (!p) return true; // empty = optional (let server enforce when required)
  const s = normalizeSaudi(p);
  return SAUDI_RE.test(s);
}

// True while user is typing (allow partial). Used to give live feedback without flicker.
export function isProgressingSaudi(p) {
  if (!p) return true;
  return SAUDI_RE_LIVE.test(p.replace(/[\s-]/g, ""));
}

export const SAUDI_HINT_EN = "Format: +9665XXXXXXXX or 05XXXXXXXX";
export const SAUDI_HINT_AR = "بصيغة +9665XXXXXXXX أو 05XXXXXXXX";
